<template>
  <div>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="header">
        <div class="back" @click="$router.go(-1)">返回</div>
        <div class="title">简历信息审核</div>
      </div>
      <template v-if="guid">
        <!-- 基础信息start -->
        <div class="basic-infor">
          <div class="import-title">
            <span class="sub-title">基础信息</span>
          </div>
          <div class="customer-information">
            <div class="cols">
              <div class="col-itms">
                <div class="title">人员姓名：</div>
                <div class="content-info w200">{{ form.name }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">联系方式：</div>
                <div class="content-info w300">{{ form.mobileNo }}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">{{ idType[form.idType] }}：</div>
                <div class="content-info w200">{{ form.idCode }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">性别：</div>
                <div class="content-info w200">{{ getName(form.sex, '性别') }}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">出生年月：</div>
                <div class="content-info w200">{{ getAgeSexByIdCard(form.idCode, 1) }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">年龄：</div>
                <div class="content-info w200">{{ getAgeSexByIdCard(form.idCode, 3) }}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">毕业院校：</div>
                <div class="content-info w200">{{ form.graduatedFrom }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">专业：</div>
                <div class="content-info w200">{{ form.professional }}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">学历：</div>
                <div class="content-info w200">{{ getName(form.education, '学历') }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">提交时间：</div>
                <div class="content-info w200">{{ form.createTime | getTimeDate }}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">简历来源：</div>
                <div class="content-info w200">{{ getName(form.sourceType, '简历来源') }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">业务员能力：</div>
                <div class="content-info w200">{{  getName(form.staffLevel, '业务员能力分类')}}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">是否有工作经历：</div>
                <div class="content-info w200">{{ form.hasWorkExperience === 'Y' ? '有' : '无' }}</div>
              </div>
            </div>
          </div>
          <img
            v-show="form.approveState && form.approveState !== 'N'"
            class="approve-img"
            :src="getApproveImg(form.approveState)"
            alt=""
          />
        </div>
        <!-- 基础信息end -->
         <!--身份证信息-->
         <div class="second"></div>
         <div class="basic-infor" v-if="idCardFrontUrl || idCardBackUrl">
          <div class="import-title">
            <span class="sub-title">附件信息</span>
          </div>
          <div class="customer-information">
                        <!--身份证照片-->
                        <div class="cols">
              <div class="col-itms">
                <div  class="idcard-front-cons common-idcard-cons">
                  <div class="card-title">
                    身份证正面
                  </div>
                  <!-- <img class="idcard-img" @click="downloadImageUseA(idCardFrontUrl,'front.png')" :src="idCardFrontUrl" /> -->
                  <el-image
                    :src="idCardFrontUrl"
                    class="idcard-img"
                    :preview-src-list="setImgList(idCardFrontUrl)"
                  >
                  </el-image>
                  <div>
                    <span class="file-preview" @click="downloadImage(idCardFrontUrl,'front.png')">下载图片</span>
                  </div>
                </div>
                <div  class="idcard-back-cons common-idcard-cons">
                  <div class="card-title">
                    身份证反面
                  </div>
                  <el-image
                    :src="idCardBackUrl"
                    class="idcard-img"
                    :preview-src-list="setImgList(idCardBackUrl)"
                  >
                  </el-image>
                  <div>
                    <span class="file-preview" @click="downloadImage(idCardBackUrl, 'back.png')">下载图片</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
         </div>
        <!-- 工作经历start -->
        <div class="second"></div>
        <template v-if="form.hasWorkExperience === 'Y'">
          <div class="customer-information" v-for="(item, index) in form.workExperienceList" :key="index">
            <div class="sub-title">工作经历{{ index + 1 }}</div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">时间：</div>
                <div class="content-info w200">{{ item.startTime  }} 至 {{ item.endTime === '至今' ? '至今' : item.endTime }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">工作单位：</div>
                <div class="content-info w200">{{ item.workUnit }}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">部门：</div>
                <div class="content-info w200">{{ item.orgName }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">职务：</div>
                <div class="content-info w200">{{ item.position }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 工作经历end -->
        <!-- 其他信息start -->
        <div class="second"></div>
        <template>
          <div class="customer-information">
            <div class="sub-title">其他信息</div>
            <div class="cols">
              <div class="other-info">
                <div class="title-col">您是否从事过终端服务相关工作？</div>
                <div class="content-info content-box">{{ getName(form.hasMarketing,'是否') }}</div>
              </div>
              <div class="other-info-second">
                <div class="title-col">(多选)您之前主要服务过以下哪类终端？</div>
                <div class="content-info content-box">
                  {{ getJSONContent(form.customerTypeJson) }}
                </div>
              </div>
            </div>
            <div class="cols">
              <div class="other-info">
                <div class="title-col">(多选)您主要从事过以下哪类产品的终端服务？</div>
                <div class="content-info content-box">
                  {{ getJSONContent(form.productTypeJson) }}
                </div>
              </div>
              <div class="other-info-second">
                <div class="title-col">您是否已备案医药代表管理要求？</div>
                <div class="content-info content-box">{{ getName(form.isFilings,'是否') }}</div>
              </div>
            </div>
            <div class="cols">
              <div class="other-info">
                <div class="title-col">备案证件</div>
                <div style="width:400px" v-if="form.filingsPaperList && form.filingsPaperList.length">
                    <div class="file-operate" style="color: #606266" v-for="item in form.filingsPaperList" :key="item.path">
                      <span class="file-name">{{ item.fileName }}</span>
                      <span class="file-preview" @click="onPreview(item)">查看详情</span>
                      <!-- <span class="file-preview" @click="onDownload(item)">下载</span> -->
                    </div>
                    <el-image-viewer v-if="showImgViewer" :url-list="imgSrcList" :on-close="closeViewer"></el-image-viewer>
                  </div>
              <div v-else style="text-align: left;">{{ '无备案证件' }}</div>
              </div>
              <div class="other-info-second">
                <div class="title-col">（多选）您认为自己能胜任市场推广的优势在于？</div>
                <div class="content-info content-box">
                  {{ getJSONContent(form.advantageJson) }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 其他信息end -->
        <!-- 审批信息start -->
        <template v-if="form.approveState !=='A'">
          <div class="second"></div>
          <div class="basic-infor">
            <div class="import-title">
              <span class="sub-title">审批信息</span>
            </div>
            <div class="customer-information">
              <div class="cols">
                <div class="col-itms">
                  <div class="title">审批人：</div>
                  <div class="content-info w200">{{ approveStaffName }}</div>
                </div>
                <div class="col-itms second">
                  <div class="title">审批时间：</div>
                  <div class="content-info w200">{{ form.approveTime | getTimeDate }}</div>
                </div>
              </div>
              <div class="cols">
                <div class="col-itms">
                  <div class="title">审批结果：</div>
                  <div class="content-info w200">{{ approveStateObj[form.approveState] || '-' }}</div>
                </div>
              </div>
              <div class="cols">
                <div class="col-itms flex-position">
                  <div class="title">原因：</div>
                  <div style="height: 60px" class="content-info content-box">{{ form.approveSuggest }}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 审批信息end -->
        <!-- 审批按钮 -->
        <div class="operte-btns">
          <!-- <div class="btn submit" v-if="form.approveState === 'Y'" @click="toAudit('S')">修改级别</div> -->
          <div class="btn submit" v-if="form.approveState === 'Y'" @click="toAudit('S')">修改级别</div>
          <div class="btn submit" v-if="form.approveState === 'A'" @click="toAudit('Y')">通过</div>
          <div class="btn reject" v-if="form.approveState === 'A'" @click="toAudit('N')">驳回</div>
          <div class="btn submit" v-if="form.approveState !== 'A'" @click="toRevoke()">撤回重审</div>
          <div class="btn cancel" @click="$router.go(-1)">取消</div>
        </div>
        <!-- 审批按钮 -->
      </template>
      <template v-else>
        <div class="no-data">
          <img src="@/assets/images/no_data.png" alt="" />
        </div>
      </template>
    </div>
    <!-- 原因弹框 -->
    <el-dialog
      :title="checkedTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @open="oepnDialog"
      width="450px"
    >
      <div slot="title" class="dialog-title">
        {{ !checkedTitle?'修改级别':'审核' }}
      </div>
      <div class="dialogCon">
        <div class="flex" style="margin-bottom:10px" v-if="checkedTitle=='通过备注'||!checkedTitle">
          <span><span style="color: red;">*</span>业务员能力：</span>
          <el-select
            size="mini"
            v-model="staffLevel"
            placeholder="请选择"
            class="w300"
            clearable
            filterable
          >
            <el-option
              v-for="item in getCodeListByKey('业务员能力分类')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 原因说明 -->
        <div class="flex" v-if="checkedTitle">
          <span><span :style="checkedTitle=='驳回理由'?'color: red;':'color:#fff;'">*</span>{{checkedTitle}}：</span>
          <div class="dialogCon-describe">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 7 }"
              v-model="checkedIssuesText"
              maxlength="100"
                 class="w300"
              show-word-limit
              :placeholder="placeholder"
              clearable
            ></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="dialogVisible = false">取 消</el-button> -->
        <el-button size="small" type="info" @click="toAuditSubmit">{{ btnTitle }}</el-button>
      </span>
    </el-dialog>
    <!--img-viewer-->
    <!-- <div class="img-viewer" v-if="showImgViewer">
      <img class="img-viewer-img" :src="imgViewerImg" />
    </div> -->
  </div>
</template>
<script>
import { getAgeSexByIdCard } from '@/uilt/tool'
import { get } from 'lodash';
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {ElImageViewer},
  data() {
    return {
      idType:{
        '1':'身份证',
        '2':'护照',
        '3':'其他'
      },
      approveStateObj: {
        A: '待审核',
        Y: '已通过',
        R: '已驳回',
        N: '初始',
      },
      getAgeSexByIdCard,
      fullscreenLoading: false,
      guid: '',
      approveStaffName:'',
      form: {
        graduatedFrom: '', // 学校
        approveState: '', // 审批状态
        name: '', // 人员姓名
        mobileNo: '', // 联系方式
        idCode: '', // 身份证
        sex: '', // 性别
        age: '', // 年龄
        professional: '', // 专业
        education: '', // 学历
        createTime: '', // 提交时间
        sourceType: '', // 简历来源
        workExperienceJson: [],
      },
      checkedTitle: '', // 弹框标题
      btnTitle: '', // 弹框标题
      checkedIssuesText: '',
      staffLevel:'',
      placeholder: '', // 输入提示
      dialogVisible: false,
      idCardFrontUrl: '',
      idCardBackUrl: '',
      showImgViewer: false,
      imgSrcList: []
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getDetail();
    // this.getNameByguid()
  },
  methods: {
    getDetail() {
      let self = this;
      let query = {
        keyword: this.$route.query.guid || this.$route.query.idCode || '',
      };
      if (!query.keyword) return;
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/get-detail?keyword=${query.keyword}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (!res.data.data) {
              this.$message.error('暂无简历信息')
              return
            }
            let form = res.data.data;
            this.$set(this,'form',form)
            // 单独处理身份证图片路径
            self.idCardBackUrl =form.idBackPictContent? JSON.parse(form.idBackPictContent).path : '';
            console.log('idCardBackUrl', this.idCardBackUrl)
            self.idCardFrontUrl = form.idFrontPictContent?JSON.parse(form.idFrontPictContent).path : '';
            console.log('idCardFrontUrl', this.idCardFrontUrl)
            this.form.workExperienceList = form.workExperienceJson ? JSON.parse(form.workExperienceJson) : []
            this.form.filingsPaperList = form.filingsPaper ? JSON.parse(form.filingsPaper) : []
            this.guid = form.guid;
            this.getNameByguid(form.approveStaffGuid)
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //提交申请
    saveReq() {
      if (!this.checkForm()) {
        return;
      }
      let form = this.form;
      let invoiceAttach = this.invoiceAttach;
      let paymentAdviceAttach = this.paymentAdviceAttach;
      let reqUrl;
      invoiceAttach.forEach((item) => {
        item.fileName = item.name;
      });
      paymentAdviceAttach.forEach((item) => {
        item.fileName = item.name;
      });
      form.paymentAdviceAttach = paymentAdviceAttach.length ? paymentAdviceAttach : null;
      form.invoiceAttach = invoiceAttach;
      if (this.guid) {
        reqUrl = `/${serverConfig.msCustomerService}/upstream-invoice-info/update`;
        form.guid = this.guid;
      } else {
        reqUrl = `/${serverConfig.msCustomerService}/upstream-invoice-info/add`;
        form.guid = null;
      }
      this.fullscreenLoading = true;
      this.api.postJson(reqUrl, form).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message({
            message: '新增成功',
            type: 'success',
          });
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 审核
    toAudit(type) {
      if (type === 'Y') {
        let flag=this.form.isSyncRoster
        this.$set(this, 'checkedTitle', '通过备注');
        this.$set(this, 'btnTitle', flag=='Y'?'审批通过':'审批通过, 去同步花名册');
        this.$set(this, 'placeholder', '输入通过备注');
        this.$set(this,'staffLevel',this.form.staffLevel)
      } else if (type === 'N') {
        this.$set(this, 'checkedTitle', '驳回理由');
        this.$set(this, 'btnTitle', '驳回');
        this.$set(this, 'placeholder', '输入驳回理由（必填）');
      }else if (type === 'S') {
        this.$set(this, 'checkedTitle', '');
        this.$set(this, 'btnTitle', '修改');
        this.$set(this, 'placeholder', '');
        this.$set(this,'staffLevel',this.form.staffLevel)
      }
      this.dialogVisible = true;
    },
    toRevoke() {
      var self = this;
      self
        .$confirm('撤回后需要重新审核，确定操作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          var req = [this.form.guid];
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/approve-revoke`, req).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('撤回成功');
              self.getDetail();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    // 提交原因
    async toAuditSubmit() {
      if (this.btnTitle === '驳回') {
        if (!this.checkedIssuesText) {
          this.$message.error('请填写理由');
          return;
        }
        this.toAuditRequire('R')
      }else if (this.btnTitle === '审批通过'){
        if (!this.staffLevel) {
          this.$message.error('业务员能力不能为空！');
          return
        }
        this.toAuditRequire('Y')
      } else if (this.btnTitle === '修改') {
        if (!this.staffLevel) {
          this.$message.error('业务员能力不能为空！');
          return
        }
        await this.toChangeLevel()
        this.$message.success('修改成功');
        this.getDetail();
      } else {
        this.toAuditRequire('Y',async (data)=>{
          let res = await this.checkHisUser(data)
          if (!res) {
            // 新用户
            this.$router.push({
              path:'/brokerInsuredEdit',
              query:{
                cvInfoGuid:data.guid,
                approvalState:'Y',
                productGuid:this.$route.query.productGuid
              }
            })
          } else if (res && res[0]){
            // ! 历史人员为编辑花名册, 花名册有的信息不赋值, 没有的信息赋值
            let item = res[0]
            let cvInfo = {
              name:data.name, // 姓名
              mobileNo:data.mobileNo, // 电话
              professional:data.professional, // 专业
              sex:data.sex, // 性别
              idCode:data.idCode, // 证件号码
              education:data.education, // 学历
              graduatedFrom:data.graduatedFrom, // 毕业学校
            }
            let cvInfoKeyList = Object.keys(cvInfo)
            cvInfoKeyList.forEach(key=>{
              if (!item[key]) item[key] = cvInfo[key]
            })
            // 老用户
            this.$router.push({
              path:'/brokerInsuredDetail',
              query:{
                item: JSON.stringify(item),
                cvInfoGuid:data.guid,
                approvalState:'Y',
                productGuid:this.$route.query.productGuid
              }
            })
          }
        })
      }
      this.dialogVisible = false;
    },
    // 判断是否为历史用户
    checkHisUser(item) {
      try {
        return new Promise((resolve, reject) =>{
           this.api.postJson(`/${serverConfig.msPersonnelService}/staff-roster/list`,{ idCode:item.idCode }).then(res=>{
             if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              resolve(res.data.data.records)
             } else {
              this.$message.error('请稍后重试');
             }
           })
        })
      } catch (error) {
        
      }
    },
    // todo审核接口
    toAuditRequire(approveState,callBack) {
      let userInfo = JSON.parse(localStorage.userInfo)
      this.fullscreenLoading = true;
      this.form.idBackPictContent =this.form.idBackPictContent?JSON.parse(this.form.idBackPictContent): null
      this.form.idFrontPictContent =this.form.idBackPictContent?JSON.parse(this.form.idFrontPictContent): null
      let query = JSON.parse(JSON.stringify(this.form))
      query.approveState = approveState
      query.approveTime = this.$moment().format('YYYY-MM-DD HH:mm:ss')
      query.approveSuggest = this.checkedIssuesText
      query.approveStaffGuid = userInfo.staffGuid
      this.api
        .put(`/${serverConfig.msPersonnelService}/staff-resume/data/update`, query)
        .then(async (res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.fullscreenLoading = false;
            if (approveState === 'R') {
              this.$router.go(-1)
            } else if (approveState === 'Y') {
               await this.toChangeLevel();
              if (callBack) {
                callBack(query) // 同步花名册
              } else {
                this.$router.go(-1)
              }
            }
          } else {
            this.$message.error(res.data.msg);
            this.fullscreenLoading = false;
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //修改级别
    toChangeLevel(){
      this.fullscreenLoading = true;
      return new Promise((resolve,reject)=>{
        this.api.postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/update-level?staffLevel=${this.staffLevel}&idCode=${this.form.idCode}`)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            resolve(true);
          } else {
            this.$message.error(res.data.msg);
          }
        })
      })
  
    },
    // 打开原因弹框的钩子
    oepnDialog() {
      this.checkedIssuesText = '';
    },
    // 详情页审批状态图片
    getApproveImg(approvalState) {
      let str = null;
      switch (approvalState) {
        case 'A':
          str = require('@/assets/images/ic_shenping.png');
          break;
        case 'Y':
          str = require('@/assets/images/ic_pass.png');
          break;
        case 'R':
          str = require('@/assets/images/ic_reject.png');
          break;
        case 'C':
          str = require('@/assets/images/ic_cancel.png');
          break;
      }
      return str;
    },
    onPreview(file) {
      var fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg') {
        this.imgSrcList = [file.path]
        this.showImgViewer = true
      } else {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
      }
    },
    closeViewer() {
      this.showImgViewer = false
    },
    getJSONContent(josnStr) {
      let str = ''
      if (josnStr) {
        let jsonObj = JSON.parse(josnStr)
        str = jsonObj.map(item=>item.name).join('、')
      }
      return str
    },
    getNameByguid(approveStaffGuid) {
      let  approveStaffGuidList = []
      if (approveStaffGuid) {
        approveStaffGuidList.push(approveStaffGuid)
      }
      this.api
        .postJson(`/${serverConfig.msPersonnelService}/staff/data/get-map-by-guids`, approveStaffGuidList)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
             let key = Object.keys(res.data.data)[0]
             this.approveStaffName = res.data.data[key]
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        // .catch(() => {
        //   this.fullscreenLoading = false;
        // });
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    previewImg(url) {
      window.open(url);
    },
    downloadImageUseA(url,filename) {
      const imageUrl = url; // 图片URL
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = filename; // 设置下载文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadImage(url, filename) {
      window.open(url + '?response-content-type=application/octet-stream')
    },
    setImgList(url) {
      return [url]
    }
  },
};
</script>
<style scoped>
/deep/.el-input-number__decrease {
  display: none;
}
/deep/.el-input-number__increase {
  display: none;
}
/deep/ .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
}
.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}
.pdt100 {
  padding-bottom: 100px !important;
}
.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}
.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}
.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
  position: relative;
}
.empty-tooltip {
  background: #fff;
  font-size: 16px;
  padding: 25px 0;
}
.import-title.second {
  margin-top: 4px;
}
.second {
  margin-top: 4px;
}
.header .title {
  text-align: center;
  flex: 1;
}
.customer-information {
  background: #fff;
  padding-bottom: 15px;
}
.customer-information .sub-title {
  text-align: left;
  font-size: 16px;
  line-height: 28px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.sub-operate-add2 {
  color: #4fa1a4;
  font-size: 14px;
  margin-left: 14px;
  cursor: pointer;
  position: absolute;
  right: 35px;
  top: 10px;
  text-align: center;
}
.sub-operate-del {
  font-size: 14px;
  color: #4fa1a4;
  cursor: pointer;
  text-align: center;
  margin: 0 20px;
}
.customer-information .cols {
  background: #fff;
  display: flex;
  padding: 4px 16px;
  padding-left: 20px;
}
.customer-information .col-itms {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.customer-information .col-itms .title {
  width: 120px;
  text-align: right;
  /* margin-right: 16px; */
}
.customer-information .col-itms.second {
  margin-left: 170px;
}
.customer-information .col-itms .title span {
  color: red;
}
.customer-information .col-itms .idcard-img{
  width: 300px;
  height: 200px;
  margin-right: 10px;
}
.import-new-wrap {
  padding-bottom: 15px;
}
.import-new-wrap .import-step-tip {
  text-align: left;
  padding-left: 10px;
  color: #666;
  font-size: 12px;
}
.import-new-wrap .col-itms {
  align-items: baseline;
}
.operte-btns {
  background: #fff;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}
.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}
.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}
.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}
.operte-btns .btn.reject {
  border: 1px solid #f56c6c;
  background-color: #ffffff;
  color: red;
  cursor: pointer;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.bank-content {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.bank-info {
  color: #a7a7a7;
}
/* 新增样式 */
.w200 {
  width: 200px;
}
.w300 {
  width: 200px;
}
.sub-title {
  color: #212121;
  font-size: 16px;
}
.title {
  color: #666666;
}
.title-col {
  color: #666666;
  text-align: left;
  height: 32px;
  line-height: 32px;
}
.content-info {
  text-align: left;
  color: #212121;
}
.other-info {
  width: 320px;
  padding-left: 70px;
}
.other-info-second {
  margin-left: 170px;
}
.content-box {
  line-height: 32px;
  width: 400px;
  min-height: 32px;
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  padding-left: 10px;
}
.content-info-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flex-position {
  align-items: start !important;
}
/deep/.el-dialog__footer {
  /* border-top: 1px solid #d9d9d9; */
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  padding: 10px 15px;
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.dialogCon {
  border-top: 1px solid #dcdee0;
  text-align: left;
  padding: 10px 20px;
}
.basic-infor {
  position: relative;
}
.approve-img {
  position: absolute;
  top: 5px;
  right: 60px;
  width: 78px;
  height: 78px;
}
.no-data {
  padding-top: 100px;
  height: 100%;
}
.flex{
  display:flex;
}
</style>
<style lang="less" scoped>
.col-itms{
  .common-idcard-cons{
    cursor: pointer;
    .card-title{
      padding-bottom: 10px;
      color: #666666;
    }
  }
}
// .img-viewer{
//   width: 100%;
//   height: 100%;
//   background: #000;
//   position: fixed;
//   top: 0;
//   left: 0;
// }
</style>
